module.exports = __webpack_public_path__ + "img/expense_category_fuel.7421a45.png";